import PropTypes from "prop-types";
import { Input } from "top-component-library";
import { DAY_LABELS, SCHEDULE_PLACEHOLDER } from "../constants";
import { DAY_ORDER } from "../scheduleUtils";
import { DayError, DayField } from "../styles";

// Seven free-text day inputs (Mon-Sun) for a weekly schedule. `values` is a
// per-day map of customer_input strings; `onChange(day, value)` updates one day.
const WeeklyScheduleInputs = ({ values, errors = {}, disabled = false, idPrefix, onChange }) => (
  <div>
    {DAY_ORDER.map((day) => (
      <DayField key={day}>
        <label htmlFor={`${idPrefix}-${day}`}>{DAY_LABELS[day]}</label>
        <Input
          id={`${idPrefix}-${day}`}
          placeholder={SCHEDULE_PLACEHOLDER}
          value={values[day] ?? ""}
          disabled={disabled}
          onChange={(event) => onChange(day, event.target.value)}
        />
        {errors[day] && <DayError>{errors[day]}</DayError>}
      </DayField>
    ))}
  </div>
);

WeeklyScheduleInputs.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  idPrefix: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WeeklyScheduleInputs;
